@if (errorForView !== 'PaymentError') {
    @if(errorMessages[errorForView]) {
        <mat-hint [translate]="errorMessages[errorForView].key"
                  [translateParams]="errorMessages[errorForView].getParams?.()"
                  [matTooltip]="errorMessages[errorForView].key | translate : (errorMessages[errorForView].getParams?.())">
        </mat-hint>
    }
} @else {
    <mat-hint [matTooltip]="validationParam">
        {{ validationParam }}
    </mat-hint>
}
